"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _Identity = _interopRequireDefault(require("../../Identity"));

/* eslint-disable no-param-reassign */
var dictatorship =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(message, channel) {
    var data, sender, requireDictator, identity;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = message.data, sender = message.sender;

            requireDictator = function requireDictator() {
              if (sender.fingerprint !== channel.rules.dictator) {
                throw new Error('Non-dictator tried to add a user');
              }
            };

            _context.t0 = data.type;
            _context.next = _context.t0 === 'ADD_MEMBER' ? 5 : _context.t0 === 'CHANGE_RULES' ? 11 : 15;
            break;

          case 5:
            requireDictator();
            _context.next = 8;
            return _Identity["default"].open(data.key);

          case 8:
            identity = _context.sent;
            channel.members.push(identity);
            return _context.abrupt("break", 16);

          case 11:
            requireDictator();
            channel.ruleSet = data.ruleSet || channel.ruleSet;
            channel.rules = data.rules;
            return _context.abrupt("break", 16);

          case 15:
            return _context.abrupt("break", 16);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function dictatorship(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = dictatorship;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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